/**
 * READ A NUMBER THAT MAY ARRIVE AS A STRING — **AND "THE WIRE" IS NOT ONE WIRE.**
 *
 * ⚠️ WHICH CLIENT FETCHED IT DECIDES THE SHAPE, and this comment says so because an earlier draft
 * did not and got it wrong. MEASURED 2026-09-19:
 *   * `supabase db query --linked` (the **Management API**) returns `numeric` as the STRING
 *     `"90.00"`. This is what `tools/web-render-20260909/dump-fixture.py` calls, so it is what the
 *     render fixture holds and what the dev stub serves.
 *   * **PostgREST** — which both the web app and the phone actually read — sends a JSON **number**.
 *     The proof is production: `SupabaseService.setLogs(forWorkoutSessionExerciseIds:)` decodes
 *     `set_logs` into `[SetLog]`, whose `weightKg` is a plain `Double?` with NO custom
 *     `init(from:)`; Swift throws `typeMismatch` on a JSON string, and his phone has decoded 174
 *     loaded sets for weeks.
 *
 * 🔴 SO THIS IS HARDENING, NOT A CRASH FIX. Raw, a string blanks a screen (`.toFixed` throws) or
 * empties a field silently (`Number.isFinite("76.50")` is false) — and that DID happen, against
 * the stub. Coercing at the read boundary makes the app correct whichever serialiser is in front
 * of it, which matters because one of ours demonstrably sends strings.
 *
 * ⚠️ AND IT IS CHEAP INSURANCE AGAINST A REAL RISK: `database.types.ts` declares these columns
 * `number | null`, and nothing in the type system would notice if a serialiser ever changed.
 */
export function wireNumber(v: unknown): number | null {
  if (v === null || v === undefined) return null;
  if (typeof v === "number") return Number.isFinite(v) ? v : null;
  if (typeof v === "string") {
    const s = v.trim();
    if (s === "") return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}
